import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import {BehaviorSubject, Observable, throwError} from 'rxjs';
import {catchError, map, tap} from 'rxjs/operators';
import { RestUrlsConfig } from "@signature-it/ngx-generic/config";
import { MobileLinksDTO, DTPagedData } from "@signature-it/ngx-generic/models";
import { IUser } from "@signature-it/ngx-generic/interfaces";
import { QuickPadDTO, FavoritesDTO, PriceDTO } from "@signature-it/ngx-catalogue/models";

@Injectable({
    providedIn: 'root'
})

export class QuickPadService_Generic {
    // protected addProductUrl = `${this.restUrlsConf.appURL}/quickPad/quick_pad_add_product`;
    protected itemPollUrl = `${this.restUrlsConf.appURL}/public/quickPad/item_poll`;
    protected itemAddUrl = `${this.restUrlsConf.appURL}/public/quickPad/item_add`;
    protected itemAddToCart = `${this.restUrlsConf.appURL}/public/quickPad/item_add_to_cart`;
    protected itemClearCart = `${this.restUrlsConf.appURL}/public/quickPad/item_clear_cart`;
    protected itemDelete = `${this.restUrlsConf.appURL}/public/quickPad/item_del`;
    protected quickPadList = `${this.restUrlsConf.appURL}/public/quickPad/quick_pad_list`;
    public itemToAdd$ = new BehaviorSubject<{}>({});

    constructor(protected http: HttpClient,
                protected restUrlsConf: RestUrlsConfig) {
    }

    /**
     * @returns Observable<>
     */
    pollProduct(data: any) : Observable<QuickPadDTO[]> {
        return this.http.post<QuickPadDTO[]>(`${this.itemPollUrl}`, JSON.stringify(data))
            .pipe(map((res) => (QuickPadDTO.createFromArray(res['data']))), catchError( (error: any) => throwError(error)));
    }

    addProduct(data: any) : Observable<QuickPadDTO[]> {
        return this.http.post<QuickPadDTO[]>(`${this.itemAddUrl}`, JSON.stringify(data))
            .pipe(map((res) => (QuickPadDTO.createFromArray(res['data']))), catchError( (error: any) => throwError(error)));
    }

    addToCart(data: any) : Observable<any> {
        return this.http.post(`${this.itemAddToCart}`, JSON.stringify(data))
            .pipe(map((res) => res), catchError( (error: any) => throwError(error)));
    }

    clearCart(): Observable<any>  {
        return this.http.post(`${this.itemClearCart}`, JSON.stringify(''))
            .pipe(map((res) => res), catchError( (error: any) => throwError(error)));
    }

    itemDel(data: any) : Observable<any> {
        return this.http.post(`${this.itemDelete}`, JSON.stringify(data))
            .pipe(map((res) => res), catchError( (error: any) => throwError(error)));
    }

    getQuickPadList()  : Observable<QuickPadDTO[]>{
        return this.http.get(`${this.quickPadList}`)
            .pipe(map((res) => QuickPadDTO.createFromArray(res['data'])), catchError( (error: any) => throwError(error)));

        }
}
